// src/app/components/reporting/types/index.ts

export interface SavedInsight {
  id:           number;
  username:     string;
  brand_name:   string;
  brand_run_id?: number | null;
  module:       string;
  title:        string;
  subtitle?:    string | null;
  metric?:      string | null;
  module_color: string;
  saved_from?:  string | null;
  raw_data:     Record<string, unknown>;
  created_at:   string;
}

export interface InsightCreatePayload {
  brand_name:   string;
  brand_run_id?: number | null;
  module:       string;
  title:        string;
  subtitle?:    string;
  metric?:      string;
  module_color?: string;
  saved_from?:  string;
  raw_data?:    Record<string, unknown>;
}

export interface ReportSection {
  title:              string;
  content:            string;
  key_metric?:        string | null;
  source_insight_ids: number[];
  reasoning:          string;
}

export interface GeneratedReport {
  id:                number;
  brand_name:        string;
  prompt:            string;
  title:             string;
  audience:          string;
  format:            string;
  confidence:        number;
  executive_summary: string;
  sections:          ReportSection[];
  key_findings:      string[];
  recommendations:   string[];
  insight_count:     number;
  created_at:        string;
}

export interface ReportGenerateRequest {
  brand_name:    string;
  prompt:        string;
  insight_ids?:  number[];
  brand_run_id?: number | null;
  audience?:     string;
  format?:       string;
}

export const MODULE_COLORS: Record<string, string> = {
  Antenna:       'var(--signal-blue)',
  Cognition:     'var(--spectral-violet)',
  'Fix Actions': 'var(--alpha-teal)',
  Analytics:     'var(--infrared-coral)',
  General:       'var(--muted-foreground)',
};

export const QUICK_STARTS = [
  {
    id: 'qs-1',
    prompt: 'Create a sales deck showing brand perception improvements with supporting metrics',
    iconName: 'Zap', color: 'var(--signal-blue)',
    format: 'Sales Deck', audience: 'Technical Buyer',
  },
  {
    id: 'qs-2',
    prompt: 'Build a board-level executive summary of brand performance vs competitors',
    iconName: 'TrendingUp', color: 'var(--spectral-violet)',
    format: 'Executive Summary', audience: 'C-Suite / Board',
  },
  {
    id: 'qs-3',
    prompt: 'Generate a client-facing briefing demonstrating ROI and brand momentum',
    iconName: 'Users', color: 'var(--alpha-teal)',
    format: 'Client Briefing', audience: 'Client / Customer',
  },
];

export const EXPORT_FORMATS = [
  { id: 'powerpoint', iconName: 'FileText', label: 'PowerPoint',     description: 'Download .pptx slides',       available: true },
  { id: 'email',      iconName: 'Mail',     label: 'Email Summary',   description: 'Copy & open in email client',  available: true },
  { id: 'link',       iconName: 'Link2',    label: 'Shareable Link',  description: 'Copy public URL to clipboard', available: true },
  { id: 'linkedin',   iconName: 'Linkedin', label: 'LinkedIn Post',   description: 'AI-formatted, ready to paste', available: true },
];